import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { Toolbox } from "../components/PageSkeleton/Toolbox";

export const Template = (props: templates.ReusableContentBlockPreview) => (
    <PageSkeleton
        {...(undefined as unknown as React.ComponentProps<typeof PageSkeleton>)} // This is only for preview, let the runtime error
        title="Reusable block preview"
        isPreview
    >
        <Toolbox value={props.object.content.value} />
    </PageSkeleton>
);
